import { MenuEntry } from '@src/menu-entry.js';

export default MenuEntry.create()
    .setTitle('Newsletter')
    .setChildren([
        MenuEntry.create()
            .setRoute('newsletter_media_viewer'),
    ]);
